<script lang="ts">
	import type { Coordinates } from '$lib/components/map/types';
	import type { ClassValue } from 'svelte/elements';
	import Icon from '$lib/components/icons/Icon.svelte';
	import ButtonMarker from '$lib/components/map/markers/ButtonMarker.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		coordinates?: Coordinates | undefined;
		class?: ClassValue;
	}

	const { coordinates, class: classes }: Props = $props();
</script>

{#if coordinates?.lng && coordinates?.lat}
	<ButtonMarker
		lngLat={[coordinates.lng, coordinates.lat]}
		markerOptions={{
			anchor: 'bottom',
		}}
		class={['rd-1 bg-transparent z-ontop', classes]}
		ariaLabel={m.poi_marker__pin()}
	>
		<span class="text-37px leading-none">
			<Icon icon="pin" tag="span" />
		</span>
	</ButtonMarker>
{/if}
